import ProjectsList from "../components/Projects/ProjectsList";

const ProjectsPage = () => {
  return <ProjectsList />;
};

export default ProjectsPage;
